import {IApiResponseBase, IRawRestQueryParams} from '../../types';
import {palipaliAPI} from '../provider/palipaliAPI';
import {RestQueryParams} from '../base/queryParams';
import {Observable} from 'rxjs';
import {ICourierJobDayStatisticsEntry, IServerReportsFilters} from '../../model/reports';

export function getCourierJobsStatisticsAPI(
    authToken: string,
    filters: IServerReportsFilters
): Observable<IApiResponseBase<ICourierJobDayStatisticsEntry[]>> {
    const url = 'api/courier_jobs/statistics';
    const fleetPartnerVehicleParams =
        filters['fleetPartnerVehicle[]']?.length > 0
            ? filters['fleetPartnerVehicle[]'].map((vehicleId) => `fleetPartnerVehicle[]=${vehicleId}`).join('&')
            : undefined;
    const courierIdParams =
        filters['courier.id[]']?.length > 0 ? filters['courier.id[]'].map((courierId) => `courier.id[]=${courierId}`).join('&') : undefined;
    const cityIdParams =
        filters['city.id[]']?.length > 0
            ? filters['city.id[]'].map((cityId) => `job.fromJobLocation.closestCity.id[]=${cityId}`).join('&')
            : undefined;
    const finishedAtParams = filters['finishedAt[before]'] ? `finishedAt[before]=${filters['finishedAt[before]']}` : undefined;
    const startedAtParams = filters['startedAt[after]'] ? `startedAt[after]=${filters['startedAt[after]']}` : undefined;
    const courierVehicleParams = filters.courierVehicle ? `courierVehicle=${filters.courierVehicle}` : undefined;

    const finalUrl =
        url +
        '?' +
        startedAtParams +
        '&' +
        finishedAtParams +
        (cityIdParams ? '&' + cityIdParams : '') +
        (courierIdParams ? '&' + courierIdParams : '') +
        (fleetPartnerVehicleParams ? '&' + fleetPartnerVehicleParams : '') +
        (courierVehicleParams ? '&' + courierVehicleParams : '');

    return palipaliAPI.get(finalUrl, new RestQueryParams(), {
        Authorization: `Bearer ${authToken}`,
    });
}
